import { Map } from 'immutable';

import { resendInvite, OPEN_RESEND_INVITE_MODAL, CLOSE_RESEND_INVITE_MODAL } from './types';

const resendInviteReducerObject = {
  [resendInvite.request]: (state) => state.setIn(['resendInviteModal', 'network', 'loading'], true),
  [resendInvite.success]: (state) =>
    state.withMutations((s) =>
      s
        .setIn(['resendInviteModal', 'network', 'loading'], false)
        .setIn(['resendInviteModal', 'network', 'error'], false),
    ),
  [resendInvite.failure]: (state, action) =>
    state.withMutations((s) =>
      s
        .setIn(['resendInviteModal', 'network', 'loading'], false)
        .setIn(['resendInviteModal', 'network', 'error'], action.error),
    ),
  [OPEN_RESEND_INVITE_MODAL]: (state, action) =>
    state.withMutations((s) =>
      s
        .setIn(['resendInviteModal', 'isOpen'], true)
        .setIn(['resendInviteModal', 'teamMember'], action.teamMember)
        .setIn(['resendInviteModal', 'network'], Map({ loading: false, error: false })),
    ),
  [CLOSE_RESEND_INVITE_MODAL]: (state) =>
    state.withMutations((s) =>
      s
        .setIn(['resendInviteModal', 'isOpen'], false)
        .setIn(['resendInviteModal', 'teamMember'], false),
    ),
};

export default resendInviteReducerObject;
